import {Vue} from 'ui.vue';

import actionMixin from './mixin/action'
import formMixin from './mixin/form'
import reCaptchaMixin from './mixin/reCaptcha'

export let Registration = {
	name: 'Registration',
	mixins: [actionMixin, formMixin, reCaptchaMixin],
	data() {
		return {
			formFields: [],
			authMode: false,
			loading: false,
			error: false,
			success: false,
			message: '',
			confirmStep: true,
			agreementChecked: false,
			userId: 0,
			timer: 5,
		}
	},
	computed: {
		redirectText() {
			return 'Вы будете перенаправлены обратно через ' + this.timer + ' сек.'
		},
		loc() {
			return Vue.getFilteredPhrases("AUTH_");
		},
		agreementError() {
			return this.errors.first('agreement');
		}
	},
	created() {
		this.$dialog.globalOptions.customClass = "modal active";
	},
	methods: {
		onConfirmedSuccess: function() {
			this.$metrika.reachGoal('avtorizacia_LK');

			this.success = true
			this.loading = false

			let limit = this.timer
			// повторить с интервалом 2 секунды
			let timerId = setInterval(() => {
				this.timer--
			}, 1000);
			setTimeout(() => { clearInterval(timerId); this.goBack(); }, limit * 1000);
		},
		goBack: function ()
		{
			if(this.isOrderPage)
			{
                window.location.reload()
				return
			}
			window.location.href = this.backUrl;
		},

		ajaxRequest: async function () {
			if (this.loading)
				return;

			let isValid = await this.isValidate();
			if (!isValid) {
				return;
			}

			let data = {};
			for (let field of this.formFields) {
				data[field.CODE] = field.VALUE;
			}

			this.loading = true;
			this.setDefault();


			BX.ajax.runComponentAction('citrus:system.auth.actions', 'registration', {
				mode: 'class',
				data: data
			})
				.then((response) => {
					let message = response.data && response.data.hasOwnProperty('message') && response.data.message ? response.data.message : false;
					if (response && response.data && response.data.hasOwnProperty('success') && response.data.success) {
						if (message)
							this.message = message;
					} else {
						this.error = true;
						this.message = message ? message : this.loc.AUTH_UNKNOWN_ERROR_MESSAGE;
					}

					if (response.data.hasOwnProperty("user_id") && response.data.user_id > 0) {
						this.userId = response.data.user_id;
						this.confirmStep = true;
					}

					this.loading = false;
				}).catch((response) => {
					this.message = response && response.errors && response.errors.length > 0 ? response.errors[0].message : this.loc.AUTH_UNKNOWN_ERROR_MESSAGE;
					this.error = true;
					this.loading = false;
			});
		},

		registerAgainRequest: function () {
			if (this.loading)
				return;

			this.loading = true;
			this.setDefault();

			BX.ajax.runComponentAction('citrus:system.auth.actions', 'registerAgain', {
				mode: 'class',
			})
				.then((response) => {
					let message = response.data && response.data.hasOwnProperty('message') && response.data.message ? response.data.message : false;
					if (response && response.data && response.data.hasOwnProperty('success') && response.data.success) {
						if (message)
							this.message = message;
					} else {
						this.error = true;
						this.message = message ? message : this.loc.AUTH_UNKNOWN_ERROR_MESSAGE;
					}

					if (response.data.hasOwnProperty("backurl")) {
						BX.reload(response.data.backurl);
					}

					this.loading = false;
				}).catch((response) => {
				this.message = response && response.errors && response.errors.length > 0 ? response.errors[0].message : this.loc.AUTH_UNKNOWN_ERROR_MESSAGE;
				this.error = true;
				this.loading = false;
			});
		},
	},
};

export default {Registration};
